var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 250 250",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.136 36.2086L213.794 6.86487C204.64 -2.29089 189.778 -2.29089 180.623 6.86487L153.021 34.4767L215.519 96.9869L243.136 69.3751C252.29 60.2116 252.29 45.3644 243.136 36.2086ZM141.97 45.5216L15.1567 172.339C14.0659 173.431 13.3232 174.819 13.0195 176.332L0.158134 240.649C-0.935616 246.116 3.88372 250.936 9.35003 249.842L73.6621 236.978C75.1748 236.676 76.5629 235.933 77.6538 234.843L204.47 108.035L141.97 45.5216Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidPen);
export default __webpack_public_path__ + "static/media/solid-pen.90752b9a0bd5dc88c16e9f83a5c8ca45.svg";
export { ForwardRef as ReactComponent };